module.exports = __webpack_public_path__ + "img/homeschooling.60f06bad.svg";